// eslint-disable-next-line import/prefer-default-export
export const thanksModalConfig = {
	moreLessons: {
		title: "You're on the right track! 🚀",
		subtitle:
			'Want more tasks to level up your English even faster? Leave your number, and our manager will contact you to unlock new lessons!',
	},
	complete: {
		title: 'Congratulations! You have completed all the tasks.',
		subtitle:
			'Leave your number, and our manager will help you take the next step toward your education! ',
	},
};
